export default function (Component) {
Component.options.__docs = "<p>You can construct a navigation by correctly nesting <code>FdSideNav</code>-related components such as <code>FdSideNavGroup</code>, <code>FdSideNavItem</code> etc. This gives you a lot of control.</p>\n"
}